import { LeftPanelPageBase } from 'components/layouts/LeftPanelPageBase/LeftPanelPageBase';
import React from 'react';
import { PasswordChangedPageStyle as S } from './PasswordChangedPage.style';
import { LinkText } from 'components/LinkText/LinkText';

export const PasswordChangedPage: React.FC = () => {
  return (
    <S.Container>
      <LeftPanelPageBase breadCrumbs="hidden" hideLeftPanel>
        <S.Container className="w-full">
          <S.Title className="mb-2">Your password has been reset</S.Title>
          <S.Text className="mt-1 mb-5">You can now close this browser.</S.Text>
          <LinkText href="/" data-testid="button-password-changed-go-to-login">
            Back to log in
          </LinkText>
        </S.Container>
      </LeftPanelPageBase>
    </S.Container>
  );
};
